/**
 * 获取系统配置
 * 如获取哪些接口需要加密
 * @author Jary 
 */

import { get } from './http';

let requestQueue = [];

/**
 * 获取加密列表
 * @returns {Promise} 返回一个 Promise 对象，解析为加密列表数据
 */
function getEncryptList() {
    // 从本地存储中获取加密列表
    let encryptList = JSON.parse(localStorage.getItem('getEncryptList')) || { time: 0, data: [] };
    return new Promise((resolve, reject) => {
        // 如果有请求在队列中，等待其完成后返回结果
        if (requestQueue.length > 0) {
            requestQueue.push(resolve);
            return;
        }
        // 判断缓存中数据是否过期超过10分钟
        if (Date.now() - encryptList.time < 10 * 60 * 1000) {
            // 如果没有过期，直接返回缓存数据
            return resolve(encryptList.data);
        } else {
            requestQueue.push(resolve);
            // 获取加密列表数据
            return get(`/config/luckydrawencrypt`, {
                isGetEncryptList: true
            }).then(({ data: responseData }) => {
                // 提取数据
                const listData = responseData.data || [];
                // 更新本地存储
                localStorage.setItem('getEncryptList', JSON.stringify({
                    time: Date.now(),
                    data: listData
                }));
                // 处理队列中的其他请求
                requestQueue.forEach(callback => callback(listData));
                requestQueue = [];
            }).catch((err) => {
                console.error("获取系统配置失败", err);
                reject(encryptList.data);
            });
        }
    });
}

// 将路径模式转换为正则表达式
function patternToRegex(pattern) {
    const regexStr =
        pattern
            .replace(/[.+?^${}()|[\]\\]/g, '\\$&') // 转义(避免正则特殊字符干扰)
            .replace(/\\\{\*\\\}/g, '[^/]+')       // {*}
            .replace(/\\\{[^}]+\\\}/g, '[^/]+') // {param}（）
        + '$';  // 添加终止的匹配

    // ⚠️ 注意：不加 ^ $
    return new RegExp(regexStr);
}

// 获取加密列表的接口
export default function () {
    return getEncryptList().catch((err) => {
        return getEncryptList()
    });
}

// 匹配url是否在加密列表中
export function matchApi(rule, ApiPathName) {
    const regex = patternToRegex(rule);
    return regex.test(ApiPathName);
}